import { ChallengeDemo } from '@/components/challenges/demos/ChallengeDemo';
import { useChallengeDetailContext } from './challengeDetailContext';

/** Demo tab on the event challenge detail page — playable minigame preview. */
export function EventChallengeDemoTab() {
  const { challenge } = useChallengeDetailContext();
  return <ChallengeDemo challenge={challenge} />;
}
